import { Input, Text } from "components/base/Form";
import { useState } from "react";
import { useDebouncedCallback } from "use-debounce";

const AssessmentExtraInfoView = ({ assessment, saveAssessment }) => {
  console.log("assessment", assessment);
  const [extraInfo, setExtraInfo] = useState({
    lowestWagesPerHour: assessment.lowestWagesPerHour,
    lowestWagesPerMonth: assessment.lowestWagesPerMonth,
    description: assessment.description,
  });

  const debouncedSave = useDebouncedCallback(saveAssessment, 1000);

  return (
    <div className="card px-6 py-4">
      <h5>Extra Info</h5>
      <div className="mt-2 space-y-2">
        <div className="space-x-3">
          <label>Lowest Wages / Month: </label>
          <Input
            className="text-center w-20"
            value={extraInfo.lowestWagesPerHour}
            onChange={(e) => {
              setExtraInfo({
                ...extraInfo,
                lowestWagesPerHour: e.target.value,
              });
              const updatedExtraInfo = {
                ...extraInfo,
                lowestWagesPerHour: e.target.value,
              };
              debouncedSave({
                variables: { id: assessment.id, extraInfo: updatedExtraInfo },
              });
            }}
          />
        </div>

        <div className="space-x-3">
          <label>Lowest Wages / Hour: </label>
          <Input
            className="text-center w-20"
            value={extraInfo.lowestWagesPerMonth}
            onChange={(e) => {
              setExtraInfo({
                ...extraInfo,
                lowestWagesPerMonth: e.target.value,
              });
              const updatedExtraInfo = {
                ...extraInfo,
                lowestWagesPerMonth: e.target.value,
              };
              debouncedSave({
                variables: { id: assessment.id, extraInfo: updatedExtraInfo },
              });
            }}
          />
        </div>
      </div>
      <div className="mt-2 opacity-70 text-xs">
        Lowest and Highest Wages / Month will be used for score computing.
      </div>

      <div className="mt-6">
        <h6>Note</h6>
        <div className="mt-2 -mx-1">
          <Text
            value={extraInfo.description}
            onChange={(e) => {
              setExtraInfo({
                ...extraInfo,
                description: e.target.value,
              });
              const updatedExtraInfo = {
                ...extraInfo,
                description: e.target.value,
              };
              debouncedSave({
                variables: { id: assessment.id, extraInfo: updatedExtraInfo },
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AssessmentExtraInfoView;
